import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function VecinosFioriCreate() {
  const { user } = useContext(AuthContext);
  const URL_VECINOS_FIORI = process.env.REACT_APP_URL_VECINOS_FIORI;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [casa, setCasa] = useState(0);
  const [email, setEmail] = useState("");
  const [codigo, setCodigo] = useState(Math.random().toString(36).substring(7));
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setNombre("");
    setApellido("");
    setCasa("")
    setCodigo("")
    setEmail("")
  };

  const saveVecinosFiori = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_VECINOS_FIORI,
        {
          is_active:"Si",
          nombre,
          apellido,
          casa,
          email,
          codigo
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Vecino Fiori",
            detalle: casa,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
      { user.menu_logs ? (
        <>
        <h3 align="center">Crea un nuevo Vecino</h3>
        <Form onSubmit={saveVecinosFiori}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
          <Label for="exampleEmail" className="mr-sm-2">
              Casa
            </Label>
            <Input
              type="number"
              placeholder="Casa"
              value={casa}
              required
              onChange={(e) => {
                setCasa(e.target.value);
              }}
            />
            <Label for="exampleEmail" className="mr-sm-2">
              Nombre
            </Label>
            <Input
              type="text"
              placeholder="Nombre"
              value={nombre}
              required
              onChange={(e) => {
                setNombre(e.target.value);
              }}
            />
            <Label for="exampleEmail" className="mr-sm-2">
              Apellido
            </Label>
            <Input
              type="text"
              placeholder="Apellido"
              value={apellido}
              required
              onChange={(e) => {
                setApellido(e.target.value);
              }}
            />
           <Label for="exampleEmail" className="mr-sm-2">
              Email
            </Label>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuFiori">
              Regresar
            </Button>
            </Row>
        </Form>
        </>
       ) : undefined}
      </div>
    </>
  );
}

export default VecinosFioriCreate;
